import React, { useMemo } from "react";
import { GlobalModal } from "../../../global/GlobalModal";
import { GlobalButton } from "../../../global/forms/GlobalFormFields";
import SafeMediaImage from "../../../global/SafeMediaImage";
import {
  PROPERTY_ASSET_COLUMN_DEFS,
  getPropertyAssetViewText,
} from "./PropertyAssetsListTable";
import "../styles/propertyAssetView.css";

function ViewField({ label, value, fullWidth = false }) {
  const text = value ?? "—";
  const rowClass = fullWidth
    ? "pa-asset-view__row pa-asset-view__row--full"
    : "pa-asset-view__row";

  return (
    <div className={rowClass}>
      <dt className="pa-asset-view__label">{label}</dt>
      <dd
        className={`pa-asset-view__value${fullWidth ? " pa-asset-view__value--remarks" : ""}`}
      >
        {text}
      </dd>
    </div>
  );
}

export default function PropertyAssetViewModal({
  open,
  onClose,
  detail,
  loading,
  columnVisibility = {},
}) {
  const visibleColumns = useMemo(
    () => PROPERTY_ASSET_COLUMN_DEFS.filter((c) => columnVisibility[c.id]),
    [columnVisibility],
  );

  const showImageColumn = columnVisibility.asset_image_url;
  const hasImage = !!detail?.asset_image_url;
  const showImagePanel = showImageColumn && hasImage;

  const fieldColumns = useMemo(
    () => visibleColumns.filter((c) => c.id !== "asset_image_url"),
    [visibleColumns],
  );

  const title = detail?.asset_code ? `Asset ${detail.asset_code}` : "Asset details";

  return (
    <GlobalModal
      open={open}
      onClose={onClose}
      title={title}
      size="lg"
      footer={
        <div style={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
          <GlobalButton onClick={onClose}>Close</GlobalButton>
        </div>
      }
    >
      <div className="pa-asset-view">
        {loading ? (
          <p className="pa-asset-view__loading">Loading asset details…</p>
        ) : detail ? (
          visibleColumns.length === 0 ? (
            <p className="pa-asset-view__empty">
              No columns selected. Use <strong>Show columns</strong> in the directory to choose
              fields for this view.
            </p>
          ) : (
            <div
              className={`pa-asset-view__body${showImagePanel ? " pa-asset-view__body--with-image" : ""}`}
            >
              <dl className="pa-asset-view__fields">
                {fieldColumns.map((col) => (
                  <ViewField
                    key={col.id}
                    label={col.label}
                    value={getPropertyAssetViewText(col.id, detail)}
                    fullWidth={col.id === "remarks"}
                  />
                ))}
                {showImageColumn && !hasImage ? (
                  <ViewField label="Image" value="—" />
                ) : null}
              </dl>
              {showImagePanel ? (
                <figure className="pa-asset-view__media">
                  <SafeMediaImage
                    src={detail.asset_image_url}
                    alt={detail.property_asset_name || "Asset"}
                    fallbackClassName="safe-media-fallback--cover"
                    iconSize={36}
                  />
                  <figcaption>Asset image</figcaption>
                </figure>
              ) : null}
            </div>
          )
        ) : null}
      </div>
    </GlobalModal>
  );
}
